var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar"},_vm._l((_vm.navs[_vm.type]),function(menu,index){return _c('router-link',{key:index,class:[menu.path == _vm.path?'active':'', 'inner'],attrs:{"to":menu.path}},[_vm._v(_vm._s(menu.name))])}))}
var staticRenderFns = []

export { render, staticRenderFns }